import type { RoomPriceRankMastInput } from "@/lib/gql/__generated__/graphql";

import type { ProductRoomPriceRankFormModel } from "../../../../type";

type Props = {
	viewModel: ProductRoomPriceRankFormModel["ViewModel"];
};

export const convertToInput = ({ viewModel }: Props) => {
	const { ranks, hotelID } = viewModel;

	const input: RoomPriceRankMastInput = {
		hotelID,
		ranks: ranks.value.map((rank) => {
			return {
				priceRankID: rank.priceRankID.value,
				name: rank.name.value,
				color: rank.color.value,
				isStopSelling: rank.isStopSelling?.value ?? false,
				rooms: rank.rooms?.value
					? rank.rooms.value.map((room) => {
							return {
								roomID: room.roomID.value,
								roomName: room.roomName.value,
								prices: room.prices?.value?.map((price) => {
									return {
										adultNum: price.adultNum.value,
										price: {
											currencyType: price.price.currencyType.value,
											amount: price.price.amount?.value ?? 0,
										},
									};
								}),
							};
						})
					: [],
			};
		}),
	} satisfies RoomPriceRankMastInput;

	return input;
};
